import FormattedMessage from 'I18n/components/FormattedMessage';
import UICloseButton from 'UIComponents/button/UICloseButton';
import Raven from 'raven-js';
import { Component } from 'react';
import styled from 'styled-components';
import { isEnabled, toggleVerboseLogging } from './operators/verboseLogging';
import { readClipboardData } from './operators/readClipboardData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LETTER_D = 68;
const Backdrop = styled.div.withConfig({
  displayName: "DebugOverlay__Backdrop",
  componentId: "sc-129k4mj-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.75);z-index:1000;"]);
const Overlay = styled.div.withConfig({
  displayName: "DebugOverlay__Overlay",
  componentId: "sc-129k4mj-1"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]);
const OverlayContent = styled.div.withConfig({
  displayName: "DebugOverlay__OverlayContent",
  componentId: "sc-129k4mj-2"
})(["background-color:white;position:relative;padding:20px;border:solid 1px;box-shadow:grey 0px 0px 10px;width:360px;"]);
const DebugButton = styled.button.withConfig({
  displayName: "DebugOverlay__DebugButton",
  componentId: "sc-129k4mj-3"
})(["margin-right:4px;margin-bottom:4px;"]);
const CloseButton = styled(UICloseButton).withConfig({
  displayName: "DebugOverlay__CloseButton",
  componentId: "sc-129k4mj-4"
})(["position:absolute;border:white;top:0;right:0;"]);
class DebugOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDebug: false,
      lastEventId: null,
      verboseLoggingEnabled: isEnabled()
    };
    this.toggleVerboseLogging = this.toggleVerboseLogging.bind(this);
    this.debugClipboardContents = this.debugClipboardContents.bind(this);
    this.sendDebugData = this.sendDebugData.bind(this);
    this.closeDebug = this.closeDebug.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  componentDidMount() {
    document.addEventListener('keyup', this.handleKeyUp);
  }
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyUp);
  }
  handleKeyUp(event) {
    const {
      altKey,
      ctrlKey,
      shiftKey,
      keyCode,
      code
    } = event;
    const isLetterD = keyCode === LETTER_D || code === 'KeyD';
    if (altKey && ctrlKey && shiftKey && isLetterD) {
      this.setState({
        showDebug: true
      });
      if (this.props.onEnterDebug) {
        this.props.onEnterDebug();
      }
    }
  }
  closeDebug() {
    this.setState({
      showDebug: false
    });
  }
  toggleVerboseLogging() {
    this.setState(state => {
      return {
        verboseLoggingEnabled: !state.verboseLoggingEnabled
      };
    });
    toggleVerboseLogging();
  }
  debugClipboardContents() {
    readClipboardData().then(clipboardData => {
      // eslint-disable-next-line no-console
      console.log('Clipboard data:', clipboardData);
      Raven.captureMessage(`Debug Clipboard ${Date.now()}`, {
        level: 'info',
        extra: clipboardData
      });
      this.setState({
        lastEventId: Raven.lastEventId()
      });
    }).catch(e => {
      // eslint-disable-next-line no-console
      console.error(`Failed to read the clipboard: ${e}`);
    });
  }
  sendDebugData() {
    Raven.captureMessage(`Debug Data ${Date.now()}`, {
      level: 'info'
    });
    this.setState({
      lastEventId: Raven.lastEventId()
    });
  }
  render() {
    if (!this.state.showDebug) {
      return null;
    }
    return /*#__PURE__*/_jsx(Backdrop, {
      children: /*#__PURE__*/_jsx(Overlay, {
        children: /*#__PURE__*/_jsxs(OverlayContent, {
          children: [/*#__PURE__*/_jsx("h3", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.title"
            })
          }), this.props.renderNetworkStatistics ? this.props.renderNetworkStatistics() : null, /*#__PURE__*/_jsx(DebugButton, {
            onClick: this.toggleVerboseLogging,
            children: this.state.verboseLoggingEnabled ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.disableLogs"
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.enableLogs"
            })
          }), /*#__PURE__*/_jsx(DebugButton, {
            onClick: this.sendDebugData,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.sendData"
            })
          }), /*#__PURE__*/_jsx(DebugButton, {
            onClick: this.debugClipboardContents,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.debugClipboard"
            })
          }), /*#__PURE__*/_jsx("br", {}), this.state.lastEventId ? /*#__PURE__*/_jsx("span", {
            style: {
              color: 'green'
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.lastEventMessage",
              options: {
                lastEventId: this.state.lastEventId
              }
            })
          }) : null, /*#__PURE__*/_jsx(CloseButton, {
            onClick: this.closeDebug
          })]
        })
      })
    });
  }
}
DebugOverlay.displayName = 'DebugOverlay';
export default DebugOverlay;